module.exports = __webpack_public_path__ + "img/BP.d8c7d84b.png";